import { ResourceHeaders } from '..'

import {
  AlertsHeader,
  AppraisalStatusHeader,
  BestOfferHeader,
  BusinessHeader,
  IdHeader,
  IndicatorHeader,
  PriceHeader,
  VehicleHeader,
  WhatsappHeader,
} from '../../headers'
import { Person } from '@/entities/persons'
import { Helpers } from '@/views/datatables/resources/helpers'

export const headers: ResourceHeaders = [
  {
    ...IdHeader,
    text: 'Nº ',
    value: '@',
    width: 90,
    options: {
      show: true,
      action: {
        edit: Helpers.linkedModel,
      },
    },
  },
  { ...AlertsHeader, text: 'Alerta', value: 'appraisalAlert', sortable: false, width: 30 },
  { ...VehicleHeader, text: 'Vehiculo', value: 'deal.auto' },
  { ...BusinessHeader, text: 'Negocio ', value: 'deal.lead.pipeline' },
  { ...AppraisalStatusHeader, text: 'Estado tasación', value: '@' },
  {
    ...WhatsappHeader,
    text: 'Ejecutivo',
    value: 'deal.lead.executive',
    options: {
      action: {
        color: 'green',
        always: true,
        icon: 'mdi-whatsapp',
        trigger: (item: Person) => Helpers.contact(item, 'Ejecutivo'),
      },
      disabledMissingProperty: ['phone'],
    },
    width: 250,
  },
  { ...PriceHeader, text: 'Diferencia para acuerdo', value: 'agreement', width: 180 },
  { ...IndicatorHeader, text: 'Indicadores', value: 'indicator' },
  /* { ...MarketPricesHeader, text: 'Precios de mercado', value: 'market.overview' }, */
  { ...BestOfferHeader, text: 'Mejor oferta', value: 'bestOffer', sortable: false },
]

export default function (): ResourceHeaders {
  return headers
}
